import { useEffect } from 'react'
import { customerData, CustomerInvoiceData } from '../../../utilities/CustomerData'
import { useNavigate } from 'react-router-dom'
import { refreshAccessToken } from '../../../utilities/extensions'
import posthog from 'posthog-js'
import { apiURL } from '../../../utilities/URLs'

export function RefundGenerateInvoice({ refundRate, refundType }) {
  const navigate = useNavigate()

  useEffect(() => {
    const handleGenerateInvoice = async () => {
      const formData = new FormData()
      formData.append('customerInvoiceInfo', JSON.stringify({
        zohoId: customerData.customerLeadData.leadId,
        customerId: customerData.customerLeadData.leadContact.contactId,
        invoiceId: customerData.customerInvoiceData.invoiceId,
        customerName: customerData.customerLeadData.leadContact.contactName,
        customerEmail: customerData.customerLeadData.leadContact.contactEmail,
        customerRefundAmount: customerData.customerLeadData.leadAmount,
        customerFee: refundRate,
        invoicePaymentType: refundType,
        currentInvoiceLink: customerData.customerInvoiceData.invoiceLinkURL
      }))

      const generateInvoiceResponse = await fetch(`${apiURL}/api/generateInvoice`, {
        method: 'POST',
        body: formData,
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const generateInvoiceData = await generateInvoiceResponse.json()

      if (generateInvoiceData.response.error) {
        if (generateInvoiceData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGenerateInvoice() : navigate('/', { state: { expired: true } })
        } else
          console.error(generateInvoiceData.response.error)
      } else {
        posthog.stopSessionRecording()
        customerData.customerInvoiceData = new CustomerInvoiceData(generateInvoiceData.response.invoiceData.invoiceInfo)

        navigate(refundType === 'Post-Paid' ? '/addPaymentMethod' : '/paymentPortal')
      }
    }

    handleGenerateInvoice()
  }, [])
  return (
    <div className='w-screen flex flex-col items-center'>
      <p className='font-bold text-center text-2xl max-sm:text-xl mb-10 max-sm:mb-4'>Customer Invoice</p>
      <p>We are processing your invoice, please wait...</p>
      <div className='flex flex-row items-center justify-center gap-2'>
        <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
        <p>Generating Invoice...</p>
      </div>
    </div>
  )
}